import React from "react";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import Styles from "Developers/AgustinGuerra/styles.module.scss";
import ProfileImage from "ProfilePictures/AgustinGuerra.jpeg";
import Map from "./imgs/marauder.gif";
import Data from "./Data/data.json";
import ContainerInfoProfile from "./Components/ContainerInfoProfile";

const AgustinGuerra: React.FC<RouteProps> = () => {
  return (
    <div className={Styles.containerBox}>
      <div className={Styles.header}>
        <h2 className={Styles.title}>{Data.name}</h2>
        <h5 className={Styles.subtitle}>{Data.position}</h5>
        <span className={Styles.help}>
          Si no ves nada, usá tu mouse como si fuera una varita. Donde cambie el
          cursor... ahí es
        </span>
      </div>
      <ContainerInfoProfile tag='img' image={ProfileImage} />

      <div className={Styles.marauder}>
        <img src={Map} alt='' />
      </div>

      {Data.content.map((el, index) => (
        <ContainerInfoProfile
          tag='p'
          content={el.text}
          title={el.title}
          key={index}
        />
      ))}
    </div>
  );
};

export default new Content({
  Component: AgustinGuerra,
  title: "Agustin Guerra",
  route: "agustin-guerra",
  tags: ["frontend", "vue", "react", "js"]
});
